import React from 'react';
import { Link } from 'react-router-dom';
import FlipBook from '../../components/FlipBook';
import './About.css';

function Handout() {
  return (
    <div className="about">
      <section className="page-hero">
        <h1>Digital Handout</h1>
        <p>Harris County Historical Society Information</p>
      </section>

      <div className="page-container">
        <div className="back-link-container">
          <Link to="/about" className="button-outline back-button">
            &larr; Back to About
          </Link>
        </div>

        <section className="section">
          <h2>Digital Handout</h2>
          <p>This digital handout provides comprehensive information about the Harris County Historical Society, our mission, programs, and membership details.</p>
          <FlipBook />
        </section>
      </div>
    </div>
  );
}

export default Handout; 